import { ButtonEl, ButtonFieldWrapper, ButtonGroup, Title } from "../DetailGraphSelector.styled";

export default function ButtonFieldView({ onActionRouteToPage }) {
    return (
        <ButtonFieldWrapper>
            <div>
                <Title>총 매출액 & 판매 건 확인</Title>
                <ButtonGroup>
                    <ButtonEl onClick={() => onActionRouteToPage('/sales-analysis/sales-channel')}>판매스토어 별</ButtonEl>
                    <ButtonEl onClick={() => onActionRouteToPage('/sales-analysis/category')}>카테고리 별</ButtonEl>
                </ButtonGroup>
            </div>
            <div>
                <Title>상품 순위 확인</Title>
                <ButtonGroup>
                    <ButtonEl onClick={() => onActionRouteToPage('/sales-analysis/product/best-product')}>상품 별</ButtonEl>
                </ButtonGroup>
            </div>
        </ButtonFieldWrapper>
    )
}